import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject, take, takeUntil } from 'rxjs';

import { RefrigerationCircuitMessagesDataDetails } from '@vi-iot/client';

import { NO_VALUE } from '@pipes';
import { ActiveDeviceError, InstallationDetailsStore } from '@store';
import { DatesService } from 'src/app/shared/services/dates.service';

@Component({
  selector: 'app-refrigerant-circuit-history-item',
  templateUrl: './refrigerant-circuit-history-item.component.html',
  styleUrls: ['./refrigerant-circuit-history-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RefrigerantCircuitHistoryItemComponent implements OnInit, OnDestroy {
  activeErrorDetailsState$: Observable<ActiveDeviceError>;

  // TODO - VIG-2257 commented temporarily
  // isExpanded = false;
  noValue = NO_VALUE;

  @Input() message: RefrigerationCircuitMessagesDataDetails;
  @Input() boilerSerial: string;
  createdTimestamp: string;
  private ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    private installationDetailsStore: InstallationDetailsStore,
    private datesService: DatesService
  ) {}
  // TODO - VIG-2257 commented temporarily
  // ngOnInit(): void {
  // const parameters = this.activeErrorsService.getSearchActiveErrorParameters(this.boilerSerial);
  // if (parameters.serial) {
  //   this.errorDetailsStore.searchErrorDetails(
  //     parameters.serial,
  //     this.entry.errorCode,
  //     parameters.countryCode,
  //     parameters.langCode
  //   );
  // }
  // this.activeErrorDetailsState$ = this.errorDetailsStore.getFullError(
  //   this.entry.errorCode,
  //   parameters.langCode
  // );
  // }

  // TODO - VIG-2257 commented temporarily
  //
  // expand(): void {
  //   this.isExpanded = !this.isExpanded;
  // }

  // TODO - VIG-2257 commented temporarily
  // ngOnDestroy(): void {
  // this.errorDetailsStore.clearErrorState();
  // }

  ngOnInit(): void {
    this.installationDetailsStore.installationTimezone$
      .pipe(take(1), takeUntil(this.ngUnsubscribe$))
      .subscribe((timeZone) => {
        this.createdTimestamp = this.datesService.getMomentFormattedDateForSpecificTimezone(
          this.message.timestamp,
          timeZone
        );
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
